import React from 'react';
import { HeroSearchTypeAhead } from '../Search';


const HeroSearch = () => {
    return <HeroSearchTypeAhead/>
};

export default HeroSearch;
